<template>
  <v-card class="elevation-5 mb-4 px-2 py-3">
    <v-container fluid grid-list-md class="ma-0 pa-0">
      <v-layout row wrap>
        <v-flex d-flex lg1 xs12>
          <h1
            class="font-weight-black mt-1 primary--text subheading text-xs-center"
          >
            Filtrar:
          </h1>
        </v-flex>
        <v-flex d-flex lg11 xs12>
          <v-layout row wrap>
            <v-flex d-flex lg6>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field
                    clearable
                    class="mt-0 pt-0"
                    data-cy="numeroGuia"
                    label="Nº Guia"
                    name="numeroGuia"
                    type="text"
                    v-model="filtro.numeroGuia"
                    @change="atualizaFiltro"
                    @click:clear="limpaNumeroGuia"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const portalStore = createNamespacedHelpers("portal");

export default {
  name: "Filtro",
  components: {},
  data() {
    return {
      dmStatusProtocolo: [],
      dmTipoSolicitacao: [],
      filtro: {}
    };
  },
  computed: {
    ...portalStore.mapGetters(["getFiltro"])
  },
  async created() {
    this.filtro = this.getFiltro;
  },
  methods: {
    atualizaFiltro() {
      this.$emit("atualizar-grid", this.filtro);
    },
    limpaNumeroGuia() {
      this.filtro = { ...this.filtro, numeroGuia: null };
      this.atualizaFiltro();
    }
  }
};
</script>
